import { SWITCH_COLORS } from '../../../components/charts/ChartSwitch';
import { fakeChartData } from '../../../util/util';
import { SlideGroup, SlideType } from './types';

import CalculationIcon from '../../../assets/img/calculation.svg';
import TradeIcon from '../../../assets/img/trade.svg';
import RefreshCwIcon from '../../../assets/img/refresh-cw.svg';
import CheckCircleIcon from '../../../assets/img/check-circle.svg';

export const pieChartOptions: Highcharts.Options = {
  chart: {
    type: 'pie',
    plotShadow: false,
    height: '100%',
  },
  title: {
    verticalAlign: 'middle',
    floating: true,
    text: 'April',
    y: 10,
    style: {
      textAlign: 'center',
    },
  },
  subtitle: {
    text: 'Company size<br>(employees)',
    verticalAlign: 'middle',
    y: 30,
    floating: true,
    style: {
      textAlign: 'center',
    },
  },
  series: [
    {
      size: '70%',
      type: 'pie',
      innerSize: '70.5%',
      data: [
        { name: '<20', y: 1, color: 'purple' },
        { name: '21-100', y: 2, color: '#39aeed' },
        { name: '>300', y: 3, color: '#db39ed' },
        { name: '101-300', y: 4, color: '#4338e8 ' },
      ],
    },
  ],
  plotOptions: {
    pie: {
      cursor: 'pointer',
      allowPointSelect: true,
      size: 70,
      dataLabels: {
        enabled: true,
        distance: -1,
      },
    },
  },
  legend: {
    enabled: false,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 400,
        },
        chartOptions: {
          chart: {
            spacing: [10, 0, 10, 0],
            margin: [0, 0, 0, 0],
            // width: 700
          },
          plotOptions: {
            pie: {
              size: 100,
              dataLabels: {
                distance: '1%',
              },
            },
          },
        },
      },
    ],
  },
};

export const lineChartOptions: Highcharts.Options = {
  chart: {
    height: 300,
    ignoreHiddenSeries: true,
    borderColor: '#ECECEC',
  },
  title: {
    text: '',
  },
  xAxis: {
    gridLineWidth: 1,
    type: 'category',
    gridLineColor: '#ECECEC',
    title: {
      text: null,
    },
  },
  yAxis: {
    gridLineWidth: 1,
    gridLineColor: '#ECECEC',
    title: {
      text: null,
    },
  },

  series: [
    {
      name: 'Total',
      type: 'line',
      data: fakeChartData().splice(0, 6),
      color: SWITCH_COLORS.Blue,
    },
    {
      type: 'line',
      name: 'Nordnet',
      data: fakeChartData().splice(0, 6),
      color: SWITCH_COLORS.Green,
    },
    {
      type: 'line',
      name: 'Avanza',
      data: fakeChartData().splice(0, 6),
      color: SWITCH_COLORS.Orange,
    },
  ],
  legend: {
    enabled: false,
  },
  exporting: {
    // showTable: true,
    // buttons: {
    //     contextButton: {
    //         menuItems: [
    //             'viewFullscreen',
    //             "printChart",
    //             'downloadPNG',
    //             'downloadSVG',
    //             'downloadJPEG',
    //             'downloadPDF',
    //             'separator',
    //             'downloadCSV',
    //             'downloadXLS',
    //             'showTable'
    //         ],
    //     },
    // },
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      pointStart: 0,
      label: {
        connectorAllowed: false,
      },
    },
  },

  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 400,
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
          },
        },
      },
    ],
  },
};

export const overviewLineChartDummyData = [
  ['2023-01-01', 32552, 4300, 2662],
  ['2023-02-01', 35390, 4300, 1772],
  ['2023-03-01', 38190, 3773, 2552],
  ['2023-04-01', 38190, 2882, 2662],
  ['2023-05-01', 42300, 2888, 2242],
  ['2023-06-01', 39500, 9292, 8342],
  ['2023-07-01', 47000, 2662, 1232],
  ['2023-08-01', 47000, 2672, 9032],
  ['2023-09-01', 47000, 2552, 2542],
  ['2023-10-01', 69000, 2662, 7342],
  ['2023-11-01', 44800, 2282, 8342],
  ['2023-12-01', 44880, 2555, 7342],
];

export const overviewPieChartDummyData = [{ y: 1 }, { y: 2 }, { y: 3 }, { y: 4 }];

export const ProcessCodeToSlideType: Record<string, SlideType> = {
  A00001: SlideType.Compute,
  A00002: SlideType.DataTransfer,
  A00003: SlideType.DataExport,
  A00004: SlideType.SystemUpdate,
};

export const RunningProcessSlideTypeConfigMap: { [key: string]: { icon: any; cardBg: string } } = {
  [`${SlideGroup.Upcoming}_${SlideType.Compute}`]: { icon: CalculationIcon, cardBg: '#c9e5f7' },
  [`${SlideGroup.Upcoming}_${SlideType.DataTransfer}`]: { icon: TradeIcon, cardBg: '#e5f7c9' },
  [`${SlideGroup.Upcoming}_${SlideType.DataExport}`]: { icon: RefreshCwIcon, cardBg: '#e5f7c9' },
  [`${SlideGroup.Past}_${SlideType.Compute}`]: { icon: CalculationIcon, cardBg: '#d3d9ca' },
  [`${SlideGroup.Past}_${SlideType.DataTransfer}`]: { icon: TradeIcon, cardBg: '#d3d9ca' },
  [`${SlideGroup.Past}_${SlideType.DataExport}`]: { icon: RefreshCwIcon, cardBg: '#d3d9ca' },
  [`${SlideGroup.Past}_${SlideType.SystemUpdate}`]: { icon: CheckCircleIcon, cardBg: '#c8d3d9' },
  default: { icon: CheckCircleIcon, cardBg: '#cce0fc' },
};
